/**** 发验证码 注册成为喜马拉雅账户 *****/
//token
export const GETTOKEN = "/passport/token/login";
//发手机验证码
export const SENDERIFYCODE = "/passport-sign-h5/v1/sign/combined/getVerifyCode";
//生成喜马拉雅账号
export const CREATEACCOUNT = "/passport-sign-h5/v1/sign/combined/verifyCode";
/********  领取会员   ********** */
export const GETVIP = "/activities/experience-vip/receive";
//活动信息
export const ACTIVITYINFO = "/activities/data/experience-vip/detail";
//是否领过会员（非连续包月）
export const IS_RECEIVED_VIP = "/activities/data/activity/check";
//是否领过会员（连续包月）
export const IS_RECEIVE_VIP = "/activities/data/experience-vip/check";
/********   是否已签约连续包月自动付费  ****** */
export const IS_SIGNED_PAY =
  "/business-user-subscription-mobile-web/userSubscription/findByDomainUserIdGroupI" +
  "d";
export const IS_SIGNED_PAY_OPEN = "/activities/data/subscription/check";
// 根据声音ID获取详情
export const GET_TRACK_DETAIL = "/activities/experience-vip/track/{id}";

/********   获取用户UID  ****** */
export const USER_INFO = "/loginUser";
// 退出登陆
export const USER_LOGOUT = "/passport/logout";



// WEBPACK FOOTER //
// ./src/service/api.js